<div class="flex my-10 justify-center w-full" *ngIf="!creating">
	<atomic-button-group
		[options]="tabOptions"
		[selected]="selectedTab"
		(onClick)="setSelectedTab($event)"
		[testHook]="testHooks.ButtonGroup"
	></atomic-button-group>
</div>

<div *ngIf="selectedTab === tabs.CREATE" class="flex flex-col mt-10">
	<div *ngIf="creating" class="flex flex-col">
		<div>Creating Docket</div>
		<div>Docket Id: {{ docketId }}</div>
		<div>Docket Name: {{ docketName }}</div>
	</div>

	<form
		*ngIf="!creating"
		(ngSubmit)="onSubmit(docketCreateForm)"
		#docketCreateForm="ngForm"
		class="flex flex-col justify-center items-center"
	>
		<app-input
			[required]="true"
			placeholder="Docket Id"
			maxLength="10"
			maxLengthLabel="Number"
			label="Docket number"
			[(ngModel)]="docketId"
			name="docketId"
			[submitted]="submitted"
			[testHook]="testHooks.DocketNumber"
		></app-input>
		<app-input
			[required]="true"
			xml-special-characters
			maxLength="35"
			maxLengthLabel="Name"
			placeholder="Docket name"
			label="Docket name"
			[(ngModel)]="docketName"
			name="docketName"
			[submitted]="submitted"
			class="mt-3"
			[testHook]="testHooks.DocketName"
		></app-input>
		<app-button
			size="small"
			type="submit"
			class="mt-10"
			[testHook]="testHooks.CreateDocketButton"
			>Create Docket</app-button
		>

		<div *ngIf="error" class="mt-10">
			{{ error }}
		</div>
	</form>
</div>

<div *ngIf="selectedTab === tabs.SEARCH" class="grid min-h-0 search-container">
	<form
		(ngSubmit)="searchDocket(docketSearchForm)"
		#docketSearchForm="ngForm"
		class="flex gap-4 items-center"
	>
		<app-input
			[required]="true"
			orientation="row"
			placeholder="Docket Name / Id"
			label="Docket"
			[(ngModel)]="docketSearchValue"
			name="docketSearchName"
			[submitted]="submittedSearch"
			[testHook]="testHooks.Docket"
		></app-input>
		<app-button type="submit" size="small" [testHook]="testHooks.SearchButton"
			>Search</app-button
		>
	</form>

	<div
		*ngIf="searching"
		class="flex w-full h-full flex-col items-center justify-center"
	>
		<app-icon
			[icon]="ICON.LOADING"
			[spin]="true"
			class="mb-3"
			[testHook]="testHooks.LoadingIcon"
		></app-icon>
		<div>Searching for dockets</div>
	</div>
	<div *ngIf="!searching && searchResults?.length > 0">
		<div class="flex font-bold border-b border-green-light-active mt-5">
			<div class="w-1/2">Docket Id</div>
			<div class="w-1/2">Docket Name</div>
		</div>
		<div class="overflow-y-auto">
			<div
				*ngFor="let docket of searchResults; trackBy: trackByDocketId"
				(click)="selectDocket(docket)"
				class="flex cursor-pointer hover:bg-grey-lightest"
				[class.selected]="docket === selectedDocket"
				[testHook]="testHooks.SelectDocketDiv"
			>
				<div class="w-1/2">
					{{ docket.docket_id }}
				</div>
				<div class="w-1/2">
					{{ docket.docket_name }}
				</div>
			</div>
		</div>
		<div class="flex justify-end mt-10" *ngIf="searchResults?.length > 0">
			<app-button
				size="small"
				(click)="assignDocket()"
				[disabled]="!selectedDocket"
				[loading]="assigning"
				[testHook]="testHooks.AssignButton"
				>Assign</app-button
			>
		</div>
	</div>
	<div
		*ngIf="searchResults?.length === 0 && !searching"
		class="mt-10 text-center"
	>
		No dockets can be found that match the search criteria '{{
			docketSearchValue
		}}'
	</div>
</div>
